import angular from 'angular';
import 'components/sharpr/notifications/notificationsModule.js';
import 'components/sharpr/partnerLinks/partnerLinksModule.js';
import 'components/sharpr/menu/menuModule.js';
import 'components/sharpr/snapEngage/snapEngageModule.js';
import 'components/sharpr/search/bar/searchBarModule.js';
import 'components/sharpr/clientChooser/clientChooserModule.js';
import 'components/sharpr/header/avatar/headerAvatarModule.js';
import 'components/sharpr/onOutsideClick/onOutsideClickDirective.js';
import 'components/sharpr/addContent/addContentModule.js';
import './headerStyles.css';
import headerLoggedinComponent from './loggedin/headerLoggedinComponent';
import headerLoggedoutComponent from './loggedout/headerLoggedoutComponent';

angular
	.module('sh.header', [
		'sh.notifications',
		'sh.partnerLinks',
		'sh.menu',
		'sh.snapEngage',
		'sh.searchBar',
		'sh.clientChooser',
		'sh.headerAvatar',
		'sh.onOutsideClick',
		'sh.addContent',
	])
	.directive('shHeaderLoggedin', headerLoggedinComponent)
	.directive('shHeaderLoggedout', headerLoggedoutComponent);
